export const emailSettingsStrings = {
    boxTitle: 'E-Mail-Einstellungen',
    enableCheckboxLabel:
        'Bei Verfügbarkeit von neuen BfR-Analyseergebnissen möchte ich eine ' +
        'E-Mail erhalten.',
    frequencies: [
        { value: 'daily', label: 'Täglich' },
        { value: 'weekly', label: 'Wöchentlich' },
        { value: 'monthly', label: 'Monatlich' }
    ],
    weekdays: [
        { value: 'monday', label: 'Montag' },
        { value: 'tuesday', label: 'Dienstag' },
        { value: 'wednesday', label: 'Mittwoch' },
        { value: 'thursday', label: 'Donnerstag' },
        { value: 'friday', label: 'Freitag' }
    ],
    weeksOfMonth: [
        { value: '1', label: '1.' },
        { value: '2', label: '2.' },
        { value: '3', label: '3.' },
        { value: '4', label: '4.' },
        { value: 'last', label: 'letzter' }
    ]
};
